import PropTypes from 'prop-types';
import { fileActions } from 'core/File';
import { useTranslation } from 'react-i18next';
import {
    Container,
    IconContainer,
    ModalButtonContainer,
    ModalContent,
    ModalTitle,
    Text
} from './styled';
import {
    DragAndDrop,
    ExpandButton,
    MaterialIcon,
    Modal
} from 'mol-ui';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector,
    useToggle
} from 'hooks';

const NewFile = ({
    folder: {
        id,
        name
    } = {},
    row = true
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        selected: {
            id: patient_id
        }
    } = useSelector('patient');
    const {
        blocked,
        status
    } = useSelector('file');

    const [file, setFile] = useState(null);
    const [error, setError] = useState(false);
    const [showModal, toggleModal, setModal] = useToggle(false);

    useEffect(() => {
        if (status === 'file-created') {
            setModal(false);
            dispatch(fileActions.setFileStatus(''));
        }
    }, [status]);

    const handleToggle = () => {
        if (!blocked) {
            toggleModal();
        }
    };

    const handleUpload = () => {
        if (validate()) {
            const { name, type } = file;
            const data = {
                file,
                folder_id: id,
                name,
                patient_id,
                type
            };
            dispatch(fileActions.createFile(data));
        }
    };

    const validate = () => {
        const newError = !file;
        setError(newError);
        return !newError;
    };
    
    return (
        <>
            {
                row
                    ? <Container disabled={ blocked } onClick={ handleToggle }>
                        <MaterialIcon icon="note_add" size={ 18 } />
                        <Text>
                            { t('Agregar nuevo archivo') }...
                        </Text>
                    </Container>
                    : <IconContainer disabled={ blocked } onClick={ handleToggle }>
                        <MaterialIcon icon="note_add" size={ 20 } />
                    </IconContainer>
            }
            <Modal active={ showModal } onToggle={ toggleModal } >
                <ModalContent>
                    <ModalTitle>
                        { t('Subir archivo a') } { name }
                    </ModalTitle>
                    <DragAndDrop
                        disabled={ status === 'file-creating' }
                        error={ error }
                        height="100px"
                        margin="0px 0px 20px 0px"
                        onFileChange={ setFile }
                    />
                    <ModalButtonContainer>
                        <ExpandButton
                            danger
                            caption={ t('Cancelar') }
                            disabled={ status === 'file-creating' }
                            size={ 80 }
                            onClick={ toggleModal }
                        />
                        <ExpandButton
                            caption={ t('Subir') }
                            loading={ status === 'file-creating' }
                            size={ 80 }
                            onClick={ handleUpload }
                        />
                    </ModalButtonContainer>
                </ModalContent>
            </Modal>
        </>
    );
};

NewFile.propTypes = {
    folder: PropTypes.object,
    row: PropTypes.bool
};

export default NewFile;
